import axios, { type AxiosError } from 'axios';
import { isErrorEnvelope, type ApiError, type ErrorEnvelope } from '@dts/shared';

/**
 * Extrai mensagem amigável de qualquer erro vindo do BFF/axios.
 * Prefere `erro.mensagem`; fallback para HTTP status; última opção: genérica.
 */
export function describeApiError(err: unknown): string {
  const api = extractApiError(err);
  if (api) return api.mensagem;
  if (axios.isAxiosError(err) && err.response) {
    return `Erro ${err.response.status} ao contatar o servidor.`;
  }
  return 'Não foi possível completar a operação. Tente novamente.';
}

/** Devolve o `ApiError` se o erro tiver envelope reconhecido; senão `null`. */
export function extractApiError(err: unknown): ApiError | null {
  if (!axios.isAxiosError(err)) return null;
  const axiosErr = err as AxiosError<ErrorEnvelope>;
  const body = axiosErr.response?.data;
  if (isErrorEnvelope(body)) return body.erro;
  return null;
}

/**
 * Mapeia `camposComErro` para o shape que o React Hook Form aceita em
 * `setError(name, { message })`.
 */
export function fieldErrorsFromApiError(
  error: ApiError,
): Array<{ campo: string; mensagem: string }> {
  return error.camposComErro ?? [];
}
